import React from "react";

import Svg, { Path, Circle } from "components/Svg";

const User = props => (
	<Svg
		width={15 * props.scale}
		height={15 * props.scale}
		viewBox="0 0 103 103"
		fill={"none"}
	>
		<Circle cx="51.5" cy="51.5" r="47.5" stroke="white" stroke-width="8"/>
		<Circle cx="51.5" cy="36.5" r="14.5" fill="white"/>

		<Path fill={props.fill || "white"}
		d="M51.5002 47.0007C68.425 47.0842 74.2759 55.5299 74.9355 75C75.0103 77.2079 73.2091 79 71 79H31.9912C29.7856 79 27.9863 77.2118 28.0533 75.0073C28.6595 55.0776 34.5487 46.9169 51.5002 47.0007Z"/>

	</Svg>
);

export default User;



// WEBPACK FOOTER //
// ./src/components/svgs/User/index.js